let defaultCourse = {
    id: null,
    title: '',
    description: null,
    recommended_duration_days: null,
    is_active: false,
    is_default_for_beginners: false,
    created_at: null,
    updated_at: null
};

export default defaultCourse;




